import type { BannerNotification, BannerNotificationType } from "@/store/bannerNotificationStore";

import { BannerNotificationView } from "./BannerNotificationView";

const dismissGroup = (items: BannerNotification[], dismiss: (id: string) => void) => {
  items.forEach((n) => {
    n.onDismiss?.();
    dismiss(n.id);
  });
};

interface AlertBannerGroupProps {
  type: BannerNotificationType;
  items: BannerNotification[];
  dismiss: (id: string) => void;
}

export const BannerNotificationGroup = ({ type, items, dismiss }: AlertBannerGroupProps) => {
  const allDismissible = items.every((n) => n.dismissible !== false);

  if (items.length === 1) {
    const [n] = items;
    const isDismissible = n.dismissible !== false;
    return (
      <BannerNotificationView
        variant={type}
        dismissible={isDismissible}
        onDismiss={isDismissible ? () => dismissGroup([n], dismiss) : undefined}
      >
        {n.message}
      </BannerNotificationView>
    );
  }

  return (
    <BannerNotificationView
      variant={type}
      dismissible={allDismissible}
      onDismiss={allDismissible ? () => dismissGroup(items, dismiss) : undefined}
    >
      <div className="flex flex-col gap-1">
        <span className="font-bold">
          {items.length} {type === "error" ? "errors" : `${type}s`} require attention
        </span>
        <ul className="flex flex-col gap-0.5">
          {items.map((n) => (
            <li key={n.id} className="flex items-start gap-1.5 text-sm font-normal">
              <span className="opacity-60">•</span>
              <span>{n.message}</span>
            </li>
          ))}
        </ul>
      </div>
    </BannerNotificationView>
  );
};
